/**
 * Рантайм-конфиг сайта. Единая точка правды для URL/env-переменных,
 * чтобы не дублировать дефолты по разным файлам.
 */

const DEFAULT_SITE_URL = 'https://bafsy.com';

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim().length > 0) {
    return stripTrailingSlash(fromEnv.trim());
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }
  return DEFAULT_SITE_URL;
}

/**
 * URL без origin-префикса браузера. Используется в скриптах build-time
 * (sitemap, robots), где `window` недоступен.
 */
export function getCanonicalSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim().length > 0) {
    return stripTrailingSlash(fromEnv.trim());
  }
  return DEFAULT_SITE_URL;
}
